module.exports = __webpack_public_path__ + "img/histoire-courte-logo.ba0e1e1e.png";